import React from 'react'
import { Helmet } from 'react-helmet'
import SecondaryHeader from '../masterLayout/SecondaryHeader'
import { Link } from 'react-router-dom'
const BenefitProfessionals = () => {
 return (
  <React.Fragment>
   <Helmet>
    <title>Benefit Professionals</title>
   </Helmet>
   <div className="benefit-professionals">
    <SecondaryHeader
     page_title="Benefit Professionals"
     banner={require('../assets/images/benefit-professionals/banner.jpg')}
    />
    <div className="sectionWrap">
     <div className="sectionContainer">
      <div className="benefit-professionals-page">
       <section className="intro-copy">
        <h4 className="lead">
         Today’s employees want care that meets them where they are. They want
         natural options that feel personal, yet effective.
        </h4>
        <h4 className="lead">At Bennabix, we offer just that.</h4>
       </section>

       <section className="two-col intro-offer">
        <div className="col media">
         <img
          src={require('../assets/images/benefit-professionals/person-pointing.jpg')}
          alt="Patient consulting with a clinician"
         />
        </div>
        <div className="col text">
         <h5 className="kicker">Allow us to introduce:</h5>
         <h4>Benefits for Medical Cannabis</h4>
         <h5 className="sub">
          a new category of care for employees managing chronic conditions
         </h5>
        </div>
       </section>

       <section className="bp-highlight">
        <h5 className="heading">
         We’re integrating medical cannabis into the healthcare conversation as a
         recognized therapeutic tool. Providing coverage, guidance, and access
         that remove barriers and reduce stigma.
        </h5>
        <h5>
         Because when patients have access to safe, effective alternatives, lives
         improve. Productivity improves. Outcomes improve.
        </h5>
       </section>

       <section className="stat-row">
        <div className="col text">
         <h5>
          Medical Cannabis has been shown to offer relief from pain, anxiety,
          insomnia, inflammation, PTSD, cancer symptoms, and more—especially when
          traditional medications fall short or cause harm.
         </h5>
         <h5>
          According to researchers at Bowling Green State University and
          Illinois State University, medical cannabis is associated with a 6%
          reduction in prescription claims. This amount is expected to grow in
          magnitude over time and gain statistical significance during the
          second full year of legalized cannabis legalization.
         </h5>
        </div>
        <aside className="col stat-card">
         <div className="percent">6%</div>
         <p>
          The amount small group insurance markets net Rx claims are reduced,
          following recreational cannabis legalization.
         </p>
        </aside>
       </section>
       <h4 className="features-heading">
         Bennabix is a forward–thinking solution that aligns with what modern
         workforces expect:
        </h4>
       <section className="features">
        <div className="grid">
         <div className="item">
          <img src={require('../assets/images/benefit-professionals/Dr-Icon.png')} alt="Qualified care icon" />
          <h5>Access to qualified medical cannabis care</h5>
          <p>
           guided by licensed professionals, personalized for individual needs.
          </p>
         </div>
         <div className="item">
          <img src={require('../assets/images/benefit-professionals/Flower-Icon.png')} alt="Savings icon" />
          <h5>Savings through a dispensary network</h5>
          <p>making effective treatment more affordable and accessible.</p>
         </div>
         <div className="item">
          <img src={require('../assets/images/benefit-professionals/Head-Icon.png')} alt="Education icon" />
          <h5>Education and support</h5>
          <p>facilitating informed decisions with confidence and compassion.</p>
         </div>
         <div className="item">
          <img src={require('../assets/images/benefit-professionals/Stethescope2-Icon.png')} alt="Outcomes icon" />
          <h5>Better health outcomes</h5>
          <p>
           naturally improving quality of life while reducing reliance on
           pharmaceuticals with harsh side effects.
          </p>
         </div>
        </div>
       </section>

       <section className="footer-cta">
        <h5>
         Bennabix helps you enhance the benefit package by giving employees a
         safe, supported path to explore plant–based medicine with real results.
        </h5>
        <p>
        Email us at team@bennabix.com or <Link to="/contact">Contact Us</Link> to learn how you can implement Bennabix.
        </p>
       </section>
      </div>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}

export default BenefitProfessionals
